(function() {
    'use strict';

    angular
        .module('prelimApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$urlRouterProvider', 'GLOBAL_URL', 'CONST_PRELIM'];

    function stateConfig($stateProvider, $urlRouterProvider, GLOBAL_URL, CONST_PRELIM) {
    	$urlRouterProvider.otherwise("/list-reward-uploaded");
    	
    	$stateProvider.state('prelim', {
    		  url: '/list-reward-uploaded',
    		  data: {
              	pageTitle: CONST_PRELIM.REWARD_LETTER
              },
              views: {
              	'content@': {
                      templateUrl: GLOBAL_URL + 'partial?uri=ga/prelim/layouts/prelim-pru-reward',  
                      controller: 'PrelimController as prelimCtr'
                   }
              }
        })
        .state('report-prelim', {
            url: '/report-reward',
            data: {
                pageTitle: CONST_PRELIM.REPORT_PRELIM_PRU_REWARD
            },
            views: {
                'content@': {
                    templateUrl: GLOBAL_URL + 'partial?uri=ga/prelim/layouts/report-prelim-pru-reward',  
                    controller: 'PrelimController as prelimCtr'
                 }
            }
      })
    }
})();
